<script setup lang="ts">
import { defineProps } from 'vue';

const { position } = defineProps({
  position: {
    type: String,
    required: false,
    default: 'bottom center'
  }
});
</script>

<template>
  <notifications
    :ignore-duplicates="true"
    animation-type="velocity"
    :position="position"
    v-bind="$attrs">
    <template #body="{ item, close }">
      <div class="app-notification" :class="item.data?.appClasses">
        <v-icon class="type-icon">{{ item.data?.icon }}</v-icon>
        <p class="text-h6 toast-notification-title" v-if="item.title">
          {{ item.title }}
        </p>
        <p class="message ma-0 pr-3 toast-notification-body">
          {{ item.text }}
        </p>
        <button class="close" @click="close" aria-label="Close notification">
          <v-icon>mdi-close</v-icon>
        </button>
        <a
          class="message ma-0 font-size-x-small font-weight-light"
          v-if="item.data.actionFn && item.data.actionText"
          @click="item.data.actionFn">
          {{ item.data.actionText }}
        </a>
      </div>
    </template>
  </notifications>
</template>
